const config = {
    //"img_baseURL": "https://portal.xgps.us/img/libauto/",

    "privatelabel": {
        "baseURL": "https://privatelabel.xgps.us",
    },
    "api": {
        "baseURL": "https://api.xgps.us/api",
        "errorURL": "https://apitest.xgps.us/api/error",
        "ver": "v1",
    },
    "exports": {
        "baseURL": "https://api.xgps.us/tmp/",
    },
    "customize": {
        "baseURL": "https://api.xgps.us/api/v1",
    },
    "files": {
        "baseURL": "https://files.prometheuspro.us/files",
    },
    "grafana": {
        "baseURL": "https://analytics.prometheuspro.dev",
    },
}
export default config